import { useState } from 'react'
import EditLine from '../../../components/admin/EditLine'
import { Button } from '../../../components/atoms'
import { Policies } from '../../../components/molecules'
import { useAuth } from '../../../hooks/useAuth'
import { useAuthContext } from '../../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { logger } from '../../../utils'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import KeyboardControl from '../../../components/molecules/KeyboardControls/KeyboardControl'
import ControlHighlight from '../../../components/molecules/KeyboardControls/ControlHighlight'
import { HighlightEffect } from '../../../enums/KeyboardControls'

export enum FocusableElement {
  LabelTitle = 'label-title',

  EditLineName = 'edit-line-name',
  EditLineEmail = 'edit-line-email',
  EditLinePassword = 'edit-line-password',

  Policies = 'account-details-policies',

  ButtonLogout = 'button-logout'
}

const AccountDetails: React.FunctionComponent = () => {
  const { userProfile, setUserProfile } = useAuth()
  const { signout } = useAuthContext()
  const navigate = useNavigate()
  const [disabled, setDisabled] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const keyboardControls = useKeyboardControls()

  const handleSignOut = (): void => {
    signout()
      .then(() => {
        setUserProfile(null)
        navigate('/')
      })
      .catch((error) => logger.error(error))
  }

  return (
    <div className='flex flex-col h-full'>
      <div className='flex justify-between px-[45px] py-[51px] items-center'>
        <h1
          id={FocusableElement.LabelTitle}
          className='text-[72px] font-bold text-[rgba(52,232,158,0.75)]'
        >
          Account Details
        </h1>
      </div>
      <div className='px-[45px]'>
        <EditLine
          id={FocusableElement.EditLineName}
          isEditable={false}
          label='Name'
          value={userProfile !== null ? `${userProfile.first_name} ${userProfile.last_name}` : ''}
          isSentryMasked={true}
        />
        <EditLine
          id={FocusableElement.EditLineEmail}
          label='Email address'
          value={userProfile !== null ? userProfile.email : ''}
          isSentryMasked={true}
        />
        <EditLine
          id={FocusableElement.EditLinePassword}
          isEditable
          label='Password'
          onPasswordSave={() => setDisabled(true)}
          onPasswordSaveComplete={() => {
            setDisabled(false)
            setIsEditing(false)
          }}
          type='password'
          value='********'
          setEditing={setIsEditing}
        />
        {/*
        // temporarily commented out for MVP https://dopage.atlassian.net/browse/DMVP-201
        {
          userProfile?.role?.slug === 'admin'
            ? <EditLine label='Job Title' value={userProfile !== null ? userProfile?.user_profile.job_title : ''} />
            : <EditLine label='Year in School' value={userProfile !== null ? userProfile?.user_profile.school_year : ''} />
        } */}

      </div>
      <div className='flex mt-auto pb-[50px] mx-8 justify-between'>
        <Policies id={FocusableElement.Policies} />
        <ControlHighlight
          active={keyboardControls.isEnabled && keyboardControls.isElementFocused(FocusableElement.ButtonLogout)}
          highlightEffect={HighlightEffect.ButtonHexOutline}
        >
          <KeyboardControl>
            <Button id={FocusableElement.ButtonLogout} disabled={isEditing || disabled} wrapperClass='w-[210px]' className='diamond-btn h-[80px] w-full font-bold flex justify-center items-center' onClick={handleSignOut} type='submit'>
              <span className='text-black text-[26px] text-neutral-090'>Log Out</span>
            </Button>
          </KeyboardControl>
        </ControlHighlight>
      </div>
    </div>
  )
}

export default AccountDetails
